<template>
    <v-chip
    x-small
    class="chips pl-2 pr-2"
    :color="ChipsColor"
    :dark="ChipsColor === 'black'">
    {{ chipText }}
    </v-chip>
</template>

<script>
export default {
name: 'Chips',
    props: {
        chipText: {
        type: String,
        default: 'Chips'
        },
        ChipsColor: {
        type: String,
        default: 'Black'
        },
    },
};
</script>

<style scoped>

</style>